import { lazy } from "react";
import { Suspense } from "react";
import { useState } from "react";
import React, { useEffect } from "react";

import * as Yup from "yup";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  Box,
  Button,
  Grid,
  InputAdornment,
  InputLabel,
  Paper,
  Stack,
  Typography,
} from "@mui/material";

import { Loader } from "../common/loader";
import DialogBox from "../common/DialogBox";
import serachImg from "../../assets/icons/search.png";
import PlainAlertMessage from "../common/PlainAlertMessage";
import { userSigupAction } from "../../redux/slices/user/userSignUpSlice";
import { serviceProviderSignupAction } from "../../redux/slices/serviceProvider/SPSignUpSlice";
import { requestDocumentsAction } from "../../redux/slices/admin/requestDocuments/requestDocumentsSlice";
import { getObjLength } from "../helpers/utils";

import "../../styles/forprofessionals.scss";

const CustomTextField = lazy(() => import("../common/CustomTextField"));
const AlertDialog = lazy(() => import("../common/AlertDialog"));

const RequestDocumentForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isAgreementModal, setIsAgreementModal] = useState(false);
  const [agreementId, setAgreementID] = useState(false);
  const [selectedItem, setSelectedItem] = useState([]);
  const [propertyList, setPropertyList] = useState(false);
  const [selectedDocumetType, setSelectedDocumetType] = useState(false);

  // store data
  const {
    requestAccessLoader,
    requestAccessDetails,
    validateUUIDDetails,
    searchedPropertyDetails,
    notifyAdminDetails,
    validateUUIDLoader,
  } = useSelector((state) => state?.serviceProviderSignup);
  const { requestedDocumentDetails, requestedDocumentLoader } = useSelector(
    (state) => state.requestDocuments
  );

  // handle request access btn for validating/searching property
  const handleValidateUUID = (values) => {
    console.log("values -->", values);

    dispatch(
      serviceProviderSignupAction.getValidateRequestDetails({
        url: "service-provider/search-property",
        data: {
          transaction_id: values?.transaction_id || undefined,
          address: values?.address || undefined,
          request_action: values?.request_action + " request",
        },
        token: true,
      })
    );
  };

  const handlePropertyDetails = (values) => {
    console.log("values -->", values);
    setAgreementID(values?.transaction_id);
    dispatch(serviceProviderSignupAction?.setSearchedPropertyDetails({}));
    dispatch(
      serviceProviderSignupAction.getValidateRequestDetails({
        url: "service-provider/get-property-details",
        data: {
          transaction_id: values?.transaction_id || undefined,
        },
        token: true,
      })
    );
  };

  const sendNotificationToAdmin = (actionType) => {
    setIsAgreementModal(true);
    dispatch(
      serviceProviderSignupAction?.getNotifyAdminRequestDetails({
        url: `service-provider/request-${actionType}`,
        data: {
          property_id: validateUUIDDetails?.data?.id || undefined,
          user_id: validateUUIDDetails?.data?.owner_id || undefined,
        },
        token: true,
      })
    );
    setSelectedDocumetType(actionType);
  };

  const handleCloseBtn = () => {
    setSelectedDocumetType(null);
    if (
      getObjLength(requestedDocumentDetails) &&
      requestedDocumentDetails?.success
    ) {
      navigate("/documents");
    }
    dispatch(serviceProviderSignupAction?.clearValidateRequestDetails());
    dispatch(serviceProviderSignupAction?.setSearchedPropertyDetails({}));
    setIsAgreementModal(false);
  };

  const handleRequestAccessBtn = (payload) => {
    let url =
      selectedDocumetType === "waiver"
        ? "service-provider/waiver-document"
        : selectedDocumetType === "termination"
        ? "service-provider/terminate-document"
        : // : values?.request_action ===
          //  REQUEST_ACCESS_ACTION[2]?.value
          // ? "service-provider/restriction-document"
          "";

    if (selectedItem?.id) {
      dispatch(
        // serviceProviderSignupAction?.getRequestAccessDetails({
        requestDocumentsAction.requestedDocument({
          url: url,
          data: {
            property_id: selectedItem?.id,
            ...payload,
          },
          token: true,
        })
      );
    }
  };

  const callAPIToGeneratePreview = (payload) => {
    dispatch(
      serviceProviderSignupAction.getSearchedPropertyDetails({
        url: `service-provider/terminate-document`,
        data: {
          property_id: selectedItem?.id,
          ...payload,
          request_pdf: true,
        },
        token: true,
      })
    );
  };

  // useEffect to download UCC form
  useEffect(() => {
    if (
      getObjLength(requestedDocumentDetails)
      //&& !requestAccessDetails?.success
      // &&
      // urlPatternValidation(requestAccessDetails?.data?.doc_link)
    ) {
      // const link = document.createElement("a");
      // link.href = requestAccessDetails?.data?.doc_link;
      // link.target = "_blank";
      // link.click();
      dispatch(serviceProviderSignupAction?.clearValidateRequestDetails());
    }
  }, [requestedDocumentDetails]);

  useEffect(() => {
    dispatch(
      userSigupAction.getStateCode({ url: "get-states-code", data: {} })
    );
  }, [dispatch]);

  useEffect(() => {
    if (validateUUIDDetails?.data?.length > 1) {
      setSelectedItem(validateUUIDDetails?.data);
      setPropertyList(true);
    } else {
      setPropertyList(false);
    }
    if (getObjLength(validateUUIDDetails?.data))
      setSelectedItem(validateUUIDDetails?.data);
  }, [validateUUIDDetails]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1,
        }}
        className="my-3"
      >
        <Typography variant="h6" className="admin_title">
          Request Termination/Waiver
        </Typography>
      </Box>
      <Box className="d-flex justify-content-start align-items-center professional-content">
        <Box
          sx={{
            bgcolor: "white",
            paddingTop: "14px",
            width: window.innerWidth < 768 ? "100%" : "95%",
            //  boxShadow: "0px 30px 70px -10px rgba(52, 75, 91, 0.29)",
            borderRadius: "15px",
          }}
          className="bg-white mt-1"
        >
          <Box className="accountBoxWrapper">
            <Formik
              enableReinitialize
              validateOnChange
              initialValues={{
                transaction_id: "",
                // address: "",
                // searched_address: "",
                // request_action: "",
              }}
              validationSchema={Yup.object().shape(
                {
                  transaction_id: Yup.string(
                    "Please enter UUID/Transaction ID."
                  )
                    .trim(
                      "The UUID/Transaction ID cannot include leading and trailing spaces"
                    )
                    .when("address", {
                      is: (a) => !a || a.length === 0,
                      then: Yup.string().required(
                        "UUID/Transaction ID is required"
                      ),
                      otherwise: Yup.string().optional().nullable(),
                    }),
                  address: Yup.string("Please enter address")
                    .trim()
                    .when("transaction_id", {
                      is: (a) => !a || a.length === 0,
                      then: Yup.string().required("Address is required"),
                      otherwise: Yup.string().optional().nullable(),
                    }),
                  request_action: Yup.string("Please select any Action"),
                  //.required("Please select any Action"),
                },
                [["transaction_id", "address"]]
              )}
              onSubmit={(values, validation) => {
                // handleValidateUUID(values);
                handlePropertyDetails(values);
              }}
            >
              {({ values, setFieldValue, touched, errors, resetForm }) => {
                return (
                  <>
                    <Form>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={10}>
                          <Suspense fallback={<div>Loading...</div>}>
                            <InputLabel
                              shrink
                              htmlFor="bootstrap-input"
                              className="request_texts"
                            >
                              Please Enter the Service Agreement # shown on the
                              UCC
                            </InputLabel>
                            <CustomTextField
                              //label="Enter your UUID/Transaction ID here"
                              name="transaction_id"
                              validation={{
                                values,
                                errors,
                                setFieldValue,
                                touched,
                              }}
                              otherProps={{
                                onChange: (event) => {
                                  if (values?.address) {
                                    setFieldValue("address", "");
                                    setFieldValue("searched_address", "");
                                  }
                                  setFieldValue(
                                    "transaction_id",
                                    event.target.value
                                  );
                                },
                              }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="start">
                                    <img
                                      className="textbox-icons"
                                      src={serachImg}
                                      alt="serachImg"
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Suspense>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={2}
                          lg={2}
                          xl={2}
                          className="d-flex justify-content-center mt-3"
                        >
                          <Button
                            variant="contained"
                            type="submit"
                            className="search-access-btn"
                          >
                            Search
                          </Button>
                        </Grid>

                        {/* <Grid
                          item
                          xs={12}
                          sm={12}
                          md={1}
                          lg={1}
                          xl={1}
                          className="d-flex justify-content-center"
                        >
                          <Stack justifyContent="center">OR</Stack>
                        </Grid>
                        <Grid item xs={12} sm={12} md={5.5} lg={5.5} xl={5.5}>
                          <ReactGoogleAutocomplete
                            className={`googleAutoComplete mw-100 br-5 ${
                              touched?.address && errors?.address?.length > 0
                                ? "autocomplete-error"
                                : ""
                            } `}
                            apiKey={GOOGLE_API_KEY}
                            value={values?.searched_address}
                            onKeyDown={(event) =>
                              event.key === "Enter"
                                ? event.preventDefault()
                                : null
                            }
                            onChange={(event) => {
                              if (values?.transaction_id) {
                                setFieldValue("transaction_id", "");
                              }
                              setFieldValue(
                                "searched_address",
                                event.target.value
                              );
                              if (!event) {
                                setFieldValue("address", "");
                                setFieldValue("searched_address", "");
                              }
                            }}
                            onPlaceSelected={(place) => {
                              if (values?.transaction_id) {
                                setFieldValue("transaction_id", "");
                              }
                              setFieldValue(
                                "address",
                                getShortNameAddressFromGoogleAutoComplete(
                                  place,
                                  "street_number"
                                ) +
                                  (getShortNameAddressFromGoogleAutoComplete(
                                    place,
                                    "street_number"
                                  )
                                    ? " "
                                    : "") +
                                  getShortNameAddressFromGoogleAutoComplete(
                                    place,
                                    "route"
                                  )
                              );
                            }}
                            libraries={["places"]}
                            options={{
                              types: ["address"],
                              componentRestrictions: { country: "us" },
                            }}
                            placeholder={`Enter User's property address`}
                          />
                          {touched?.address && errors?.address?.length > 0 && (
                            <Typography
                              sx={{
                                color: "#d32f2f !important",
                                fontSize: "12px !important",
                                margin: "5px 0px 0px 15px !important",
                                maxWidth: "100% !important",
                                textAlign: "left",
                              }}
                            >
                              {errors?.address}
                            </Typography>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <FormControl
                            fullWidth
                            className="sign-textField "
                            error={
                              touched.request_action &&
                              Boolean(errors.request_action)
                            }
                          >
                            <InputLabel
                              // id="demo-simple-select-placeholder"
                              style={{ color: "#00000075" }}
                              label="request_action"
                            >
                              Select what you want to do
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-placeholder"
                              id="demo-simple-select"
                              value={values?.request_action}
                              // label="Select what you want to do"
                              name="request_action"
                              variant="outlined"
                              onChange={(event) => {
                                setFieldValue(
                                  "request_action",
                                  event.target.value
                                );
                              }}
                              MenuProps={MenuProps}
                            >
                              {REQUEST_ACCESS_ACTION?.map((option) => (
                                <MenuItem value={option?.value}>
                                  {option?.label}
                                </MenuItem>
                              ))}
                            </Select>
                            {touched.request_action &&
                              Boolean(errors.request_action) && (
                                <FormHelperText sx={{ color: "#d32f2f" }}>
                                  {touched.request_action &&
                                    errors.request_action}
                                </FormHelperText>
                              )}
                          </FormControl>
                        </Grid>
                        <Box className="text-center request-access-box ">
                          <Button
                            variant="contained"
                            type="submit"
                            className="request-access-btn mt-4"
                          >
                            Request Access
                          </Button>
                        </Box> */}
                      </Grid>
                    </Form>

                    {getObjLength(validateUUIDDetails) ? (
                      validateUUIDDetails?.success ? (
                        <>
                          <DialogBox
                            dividers
                            width={"sm"}
                            title={
                              getObjLength(notifyAdminDetails) ? null : (
                                <span>Service Agreement # {agreementId}</span>
                              )
                            }
                            titleClass="text-start py-4 px-2"
                            contentClassName={"bg-white p-0"}
                            openPopup={validateUUIDDetails?.success}
                            onClose={() => {
                              dispatch(
                                serviceProviderSignupAction?.clearValidateRequestDetails()
                              );
                              resetForm();
                            }}
                            content={
                              <div>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    padding: { xs: "20px", md: "34px" },
                                    mb: getObjLength(notifyAdminDetails)
                                      ? 0
                                      : 5,
                                    minWidth: { xs: "90%", md: "60%" },
                                    backgroundColor: getObjLength(
                                      notifyAdminDetails
                                    )
                                      ? "white"
                                      : "#F6F9FC",
                                    boxShadow: "0px 2px 2px 0px #344B5B0F",
                                    borderRadius: "5px",
                                  }}
                                >
                                  {getObjLength(notifyAdminDetails) ? (
                                    <PlainAlertMessage
                                      type={
                                        notifyAdminDetails?.success
                                          ? "Success"
                                          : "Error"
                                      }
                                      openPopup={true}
                                      onClose={true}
                                      onCloseFun={() => {
                                        dispatch(
                                          serviceProviderSignupAction?.clearValidateRequestDetails()
                                        );
                                        resetForm();
                                      }}
                                      message={
                                        <>
                                          {notifyAdminDetails?.success ? (
                                            <Typography
                                              variant="subtitle1"
                                              sx={{ minWidth: 90 }}
                                            >
                                              Your request has been successfully
                                              submitted. Any further actions
                                              related to the{" "}
                                              {selectedDocumetType} of this
                                              property will be handled by the
                                              admin.{" "}
                                            </Typography>
                                          ) : (
                                            notifyAdminDetails?.data?.message
                                          )}
                                        </>
                                      }
                                      footer={false}
                                    />
                                  ) : (
                                    <div className="  bg-white p-4 text-start">
                                      <Stack
                                        display={"flex"}
                                        direction={{ xs: "column", md: "row" }}
                                        alignContent={"center"}
                                        justifyContent={{ md: "flex-start" }}
                                        mb={2}
                                      >
                                        <Typography
                                          variant="subtitle1"
                                          fontWeight="bold"
                                          sx={{ minWidth: 90 }}
                                        >
                                          Owner:
                                        </Typography>
                                        <Typography variant="subtitle1">
                                          {
                                            validateUUIDDetails?.data
                                              ?.property_details?.OwnerInfo?.[
                                              "Owner Name"
                                            ]
                                          }
                                        </Typography>
                                      </Stack>
                                      <Stack
                                        display="flex"
                                        direction={{ xs: "column", md: "row" }}
                                        alignContent={"center"}
                                        justifyContent={{ md: "flex-start" }}
                                        mb={2}
                                      >
                                        <Typography
                                          variant="subtitle1"
                                          fontWeight="bold"
                                          sx={{ minWidth: 90 }}
                                        >
                                          Address:
                                        </Typography>
                                        <Typography variant="subtitle1">
                                          {
                                            validateUUIDDetails?.data
                                              ?.property_details?.GeneralInfo
                                              ?.Address
                                          }
                                        </Typography>
                                      </Stack>
                                    </div>
                                  )}
                                </Paper>

                                {getObjLength(notifyAdminDetails) ? null : (
                                  <Stack
                                    direction={"row"}
                                    spacing={2}
                                    pb={2}
                                    className="request_doc_button_wrapper"
                                  >
                                    <Button
                                      className="refi_waiver_Btn success_popup_btn"
                                      variant="contained"
                                      onClick={() =>
                                        sendNotificationToAdmin("waiver")
                                      }
                                    >
                                      Refi-Waiver
                                    </Button>
                                    <Button
                                      className="sale_termination_Btn"
                                      onClick={() =>
                                        sendNotificationToAdmin("termination")
                                      }
                                    >
                                      Sale-Termination
                                    </Button>
                                  </Stack>
                                )}
                              </div>
                            }
                          />
                        </>
                      ) : (
                        <Suspense fallback={<div>Loading...</div>}>
                          <AlertDialog
                            type="Error"
                            openPopup={true}
                            onClose={true}
                            onCloseFun={() => {
                              dispatch(
                                serviceProviderSignupAction?.clearValidateRequestDetails()
                              );
                              resetForm();
                              // handleCloseBtn();
                            }}
                            mesage={
                              <>
                                <Typography px={3}>
                                  {validateUUIDDetails?.data?.message}
                                </Typography>
                                {/* {validateUUIDDetails?.data?.errors
                                  ?.show_error ? (
                                  <Typography px={3}>
                                    {validateUUIDDetails?.data?.message}
                                  </Typography>
                                ) : (
                                  <Typography px={3}>
                                    Please ensure you've used the correct code
                                    and that the sender has granted full access
                                    to this resource. Also, confirm that the
                                    searched property has an active
                                    subscription.
                                  </Typography>
                                )} */}
                              </>
                            }
                            buttons={
                              <Button
                                className="popup_Btn error_popup_btn mx-2"
                                onClick={() => {
                                  dispatch(
                                    serviceProviderSignupAction?.clearValidateRequestDetails()
                                  );
                                  resetForm();
                                }}
                              >
                                Close this window
                              </Button>
                            }
                          />
                        </Suspense>
                      )
                    ) : null}
                  </>
                );
              }}
            </Formik>
          </Box>
        </Box>
      </Box>

      {/* open form based on action */}
      {/* {selectedDocumetType === "waiver" ? (
        <Suspense fallback={<div>Loading...</div>}>
          <WaiverDocumentFormModal
            open={isAgreementModal}
            selectedData={validateUUIDDetails?.data}
            loader={requestAccessLoader}
            handleClose={() => {
              handleCloseBtn();
            }}
            onSubmit={(payload) => handleRequestAccessBtn(payload)}
            setSelectedItem={setSelectedItem}
            selectedItem={selectedItem}
            setPropertyList={setPropertyList}
            propertyList={propertyList}
          />
        </Suspense>
      ) : selectedDocumetType === "termination" ? (
        <Suspense fallback={<div>Loading...</div>}>
          <TerminateDocumentFormModal
            open={isAgreementModal}
            selectedData={validateUUIDDetails?.data}
            loader={requestAccessLoader}
            handleClose={() => {
              handleCloseBtn();
            }}
            previewPDFAPICall={(payload) => callAPIToGeneratePreview(payload)}
            onSubmit={(payload) => handleRequestAccessBtn(payload)}
            setSelectedItem={setSelectedItem}
            selectedItem={selectedItem}
            setPropertyList={setPropertyList}
            propertyList={propertyList}
          />
        </Suspense>
      ) : //  : selectedDocumetType==='restriction'? (
      //    <Suspense fallback={<div>Loading...</div>}>
      //      <RestrictionDocumentFormModal
      //        open={validateUUIDDetails?.success}
      //        selectedItem={validateUUIDDetails?.data}
      //        loader={requestAccessLoader}
      //        handleClose={() => {
      //          dispatch(
      //            serviceProviderSignupAction?.clearValidateRequestDetails()
      //          );
      //          handleCloseBtn();
      //        }}
      //        onSubmit={(payload) =>
      //          handleRequestAccessBtn(payload)
      //        }
      //      />
      //    </Suspense>
      //)
      null} */}

      <Loader open={validateUUIDLoader || requestedDocumentLoader} />
    </>
  );
};

export default RequestDocumentForm;
